import React from 'react';

export const CarouselItem: React.FC<ICarouselItem> = ({
  item,
  inView = false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick = () => {},
}) =>
  React.cloneElement(item, {
    onClick,
    'data-test': 'CarouselItem',
    inview: inView ? 1 : 0,
  });

interface ICarouselItem {
  item: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  inView?: boolean;
  onClick?: () => void;
}
